import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import { DataSource } from "model/datasource";

interface DatasourceItemProps {
  datasourceData: DataSource;
}

export default function DatasourceItem({
  datasourceData,
}: DatasourceItemProps) {
  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div>
          <a href={`/datasource/${datasourceData?.id}`}>
            <span style={styles.name}>{datasourceData?.name}</span>
          </a>
          <span
            style={{
              backgroundColor: datasourceData?.is_active ? "green" : "red",
              color: "white",
              padding: 5,
              borderRadius: 20,
              marginLeft: 10,
              fontSize: 12
            }}
          >
            {datasourceData?.is_active ? "Enable" : "Disable"}
          </span>
        </div>
        <span style={styles.projectName}>{datasourceData?.datasource_type_name}</span>
      </div>
      <div style={styles.info}>
        <span>Project: {datasourceData?.project}</span>
        <br />
        <span>Host: {datasourceData?.datasource_host}</span>
        <br />
        <span>Port: {datasourceData?.datasource_port}</span>
        <br />
        <span>Description: {datasourceData?.description}</span>
        <br />
        <br />
      </div>
    </div>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    padding: 12,
    border: "1px solid var(--color-line)",
    borderRadius: 4,
  },
  name: {
    fontSize: 18,
    fontWeight: 500,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  projectName: {
    fontSize: 16,
    padding: 6,
    color: "var(--color-accent-dark)",
    fontWeight: 500,
  },
  info: {
    fontSize: 14,
    color: "var(--secondary)",
  },
};
